const menuItemsData = [
  {
    link: '/',
    text: 'Home',
    icon: 'fa-home'
  },
  {
    link: '/articles',
    text: 'My Articles',
    icon: 'fa-file-text'
  },
  {
    link: '/recommendations',
    text: 'Recommendations',
    icon: 'fa-star'
  },
  {
    link: '/daily-news',
    text: 'Daily News',
    icon: 'fa-bullhorn'
  },    
  {
    link: '/newsletters',
    text: 'Newsletters',
    icon: 'fa-newspaper-o'
  },
  {
    link: '/open-source',
    text: 'Open Source',
    icon: 'fa-github'
  },
  {
    link: '/community',
    text: 'Community',
    icon: 'fa-comments'
  },
  {
    link: '/team',
    text: 'Our Team',
    icon: 'fa-users'
  },
];

export default menuItemsData;